// ═══════════════════════════════════════════════════════════════
// VOLUNTEEROS — Module Layout with sub-navigation
// ═══════════════════════════════════════════════════════════════

import { Outlet, useLocation } from 'react-router-dom';
import {
  IconLayoutDashboard, IconCalendarEvent, IconClipboardCheck,
  IconUsers, IconMapPin, IconCalendar, IconTool,
  IconReportAnalytics, IconChartBar, IconMessageCircle, IconSettings,
} from '@tabler/icons-react';
import { useFilteredNav } from '../../hooks/useFilteredNav';
import type { NavItem } from '../../types/nav';
import ModuleNav from '../../components/layout/ModuleNav';
import Breadcrumbs from '../../components/ui/Breadcrumbs';

const NAV_ITEMS: NavItem[] = [
  { label: 'Dashboard', path: '/volunteer', icon: IconLayoutDashboard, exact: true },
  { label: 'Events', path: '/volunteer/events', icon: IconCalendarEvent },
  { label: 'Schedule', path: '/volunteer/schedule', icon: IconCalendar },
  { label: 'Check-In', path: '/volunteer/checkin', icon: IconClipboardCheck },
  { label: 'Volunteers', path: '/volunteer/roster', icon: IconUsers, hiddenFromSlugs: ['ext_volunteer'] },
  { label: 'Event Map', path: '/volunteer/map', icon: IconMapPin },
  { label: 'Scheduler', path: '/volunteer/scheduler', icon: IconTool, minLevel: 'editor' },
  { label: 'Reports', path: '/volunteer/reports', icon: IconReportAnalytics, minLevel: 'editor' },
  { label: 'Analytics', path: '/volunteer/analytics', icon: IconChartBar, minLevel: 'editor' },
  { label: 'Comms', path: '/volunteer/comms', icon: IconMessageCircle, minLevel: 'editor' },
  { label: 'Settings', path: '/volunteer/settings', icon: IconSettings, minLevel: 'admin' },
];

export default function VolunteerLayout() {
  const { pathname } = useLocation();
  const visibleItems = useFilteredNav('volunteer', NAV_ITEMS);

  const currentPage = NAV_ITEMS.find(item =>
    item.exact ? pathname === item.path : pathname.startsWith(item.path)
  );

  return (
    <div style={{ padding: '24px' }}>
      <Breadcrumbs
        items={[
          { label: 'Hub', to: '/' },
          { label: 'Volunteer', to: '/volunteer' },
          ...(currentPage && currentPage.path !== '/volunteer' ? [{ label: currentPage.label }] : []),
        ]}
      />
      <ModuleNav items={visibleItems} />
      <Outlet />
    </div>
  );
}
